import { render, staticRenderFns } from "./CandidateLogCreateForm.vue?vue&type=template&id=618d9535&scoped=true&"
import script from "./CandidateLogCreateForm.vue?vue&type=script&lang=js&"
export * from "./CandidateLogCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./CandidateLogCreateForm.vue?vue&type=style&index=0&id=618d9535&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618d9535",
  null
  
)

/* custom blocks */
import block0 from "./CandidateLogCreateForm.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./CandidateLogCreateForm.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VIcon,VTextarea})
